export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Procuro',
  frontPageProvideTitle: 'Ofereço',
  frontPagePersonalCenterTitle: 'Perfil',
  login: 'Entrar',
  home_chatWithOctopie: 'Entendendo seus pensamentos',
  home_chatNeedUnderstood: 'Seus pensamentos foram compreendidos',
  home_draftBannerTitle: 'Finalize sua mensagem',
  home_draftBannerSubtitle: 'A IA já preparou sua mensagem — toque para continuar',
  home_tabHome: 'Início',

  // App.vue
  appRequirementTitle: 'Valorizamos cada sugestão e cada feedback',
  appRequirementBtn: 'Enviar',
  appSubmitSuccess: 'Enviado com sucesso, obrigado pelo seu feedback',
  appFeedbackLink: 'Sugestões/Feedback',
  mobile_banner_text: 'Para a melhor experiência, use nosso app',
  mobile_banner_btn: 'Baixar o app',

  // Common
  loading: 'Carregando...',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  save: 'Salvar',
  delete: 'Excluir',
  edit: 'Editar',
  add: 'Adicionar',
  search: 'Pesquisar',
  refresh: 'Atualizar',
  change_batch: 'Embaralhar',
  back: 'Voltar',
  submit: 'Enviar',
  close: 'Fechar',
  ok: 'OK',
  yes: 'Sim',
  no: 'Não',
  send: 'Enviar',
  block: 'Bloquear',
  more: 'Mais',
  logout: 'Sair',
  settings: 'Configurações',
  view_guide: 'Ver guia',
  feedback: 'Feedback',
  feedback_title: 'Feedback',
  feedback_new: 'Novo feedback',
  feedback_empty: 'Nenhum feedback ainda',
  feedback_hint: 'Conte o que você pensa...',
  feedback_submit: 'Enviar',
  feedback_submit_success: 'Feedback enviado com sucesso',
  feedback_submit_failed: 'Falha ao enviar o feedback',
  feedback_reply_label: 'Resposta da plataforma',
  register: 'Cadastrar',
  name: 'Nome',
  email: 'E-mail',
  mobile: 'Celular',
  password: 'Senha',
  verification_code: 'Código de verificação',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Todos os direitos reservados.',
  footerVersion: 'Versão {version}',
  copy: 'Copiar',
  regenerate: 'Regerar',
  generate: 'Gerar',
  contact_now: 'Conversar',
  yours: 'você',
  xiaoyao_analysis: 'Análise de IA',
  brand_name: 'OctoSay',
  anonymous: 'Anônimo',
  no_summary: 'Sem resumo',
  file: 'Arquivo',
  discover: 'Descobrir',
  discover_title: 'Descobrir',
  discover_hotChannels: 'Canais populares',
  discover_allChannels: 'Todos',
  discover_searchChannel: 'Pesquisar canal',
  discover_noChannels: 'Nenhum canal encontrado',

  // Messages
  operationSuccess: 'Operação bem-sucedida',
  operationFailed: 'Falha na operação',
  networkError: 'Erro de rede, tente novamente mais tarde',
  dataLoadingFailed: 'Falha ao carregar os dados',
  noData: 'Sem dados',
  deleteConfirm: 'Tem certeza de que deseja excluir?',
  saveConfirm: 'Tem certeza de que deseja salvar?',

  // Form Validation
  required: 'Este campo é obrigatório',
  emailInvalid: 'Digite um endereço de e-mail válido',
  phoneInvalid: 'Digite um número de telefone válido',
  passwordTooShort: 'A senha deve ter pelo menos {min} caracteres',
  passwordMismatch: 'As senhas não coincidem',

  // Time
  today: 'Hoje',
  yesterday: 'Ontem',
  justNow: 'Agora mesmo',
  minutesAgo: 'há {min} min',
  hoursAgo: 'há {hour} h',
  daysAgo: 'há {day} d',

  // Footer
  about: 'Sobre',
  footerPrivacy: 'Política de Privacidade',
  footerTerms: 'Termos de Serviço',
  footerSupport: 'Ajuda e suporte',

  // Register
  registerAgeConfirm: 'Confirmo que tenho pelo menos 13 anos',
  registerAgeConfirm18: 'Confirmo que tenho pelo menos 18 anos',
  registerTermsPrefix: 'Eu li e concordo com ',
  registerTermsAnd: ' e ',
  registerAgeError: 'Confirme sua idade',
  registerTermsError: 'Aceite os termos e a política de privacidade',

  // Chat
  chatPrivacyTip: 'Escreva sua mensagem no grupo e a IA conversará com você primeiro para esclarecer. Depois que você confirmar, sua mensagem e o resumo da IA são publicados juntos e o AI continua buscando correspondências.',
  aiChat_quickSuggestions: 'Tente dizer',
  aiChat_welcome: "Oi! Me conta o que você procura.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Detalhes compreendidos — publique para encontrar seu match',
  aiChat_readyToPostHint: 'Continue conversando para adicionar detalhes ou atualizar o resumo a qualquer momento',
  aiChat_progressStep1: 'Entender os detalhes',
  aiChat_progressStep1Done: 'Detalhes compreendidos',
  aiChat_progressStep2: 'Resumo da IA',
  aiChat_progressStep2Desc: "O AI cria um resumo para o match",
  aiChat_progressStep3: 'Publicar no Grupo',
  aiChat_progressStep3Desc: 'Publique e encontre seu match',
  aiChat_publishExtraHint: 'Digite sua mensagem para o grupo',
  aiChat_publishMsgRequired: 'Obrigatório',
  aiChat_publishMsgLabel: 'Sua mensagem para o grupo',
  aiChat_matchSummaryLabel: 'Resumo da IA',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'O conteúdo a seguir foi gerado por IA e é apenas para referência.',
  aiChat_publishSuggestionHint: 'Toque para substituir',
  aiChat_allowDirectContact: 'Permitir contato direto',
  aiChat_allowDirectContactDesc: 'Outras pessoas podem te contatar diretamente sem precisar de match',
  channel_chat_session_publishToChannel: 'Publicar no Grupo Octo',
  aiChat_newChat: 'Redefinir',

  // Channels / Grupos
  home_tabChannels: 'Grupos Octo',
  channels_title: 'Grupos Octo',
  channels_myChannels: 'Grupos que você entrou',
  channels_discover: 'Descobrir',
  channels_noChannels: 'Nenhum grupo ainda',
  channels_noMyGroupsTitle: 'Você ainda não entrou em nenhum grupo',
  channels_noMyGroupsSubtitle: 'Pesquise um grupo para entrar e comece a se conectar',
  channels_searchGroupsBtn: 'Pesquisar grupos',
  channels_loginPrompt: 'Entre para ver os grupos',
  channels_create: 'Criar Grupo Octo',
  channels_search: 'Pesquisar Grupos Octo',
  channels_searchMyGroups: 'Pesquisar meus Grupos Octo',
  channels_searchHint: 'Pesquisar',
  channels_searchHintChats: 'Pesquisar conversas...',
  channels_searchHintGroups: 'Pesquisar grupos...',
  channels_searchHintMy: 'Pesquisar grupos que você entrou...',
  channels_joinByCode: 'Entrar com código',
  channels_joinByCodeTitle: 'Entrar no Grupo Octo com código',
  channels_joinByCodeHint: 'Digite o código do Grupo Octo',
  channels_joinByCodeConfirm: 'Entrar',
  channels_joinByCodeNotFound: 'Grupo não encontrado',
  channels_createNewGroup: 'Criar um novo Grupo Octo',
  channels_noResults: 'Nenhum grupo encontrado',
  channel_detail_join: 'Entrar',
  channel_detail_leave: 'Sair',
  channel_detail_members: 'membros',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} entrou no hub',
  channelJoinMsg_twoJoined: '{name1} e {name2} entraram no hub',
  channelJoinMsg_multiJoined: '{name1}, {name2} e mais {n} entraram no hub',
  channelJoinMsg_oneAndMoreJoined: '{name} e mais {n} entraram no hub',
  channelJoinMsg_membersJoined: '{n} membros entraram no hub',

  // Feed
  channels_feed: 'Conversas',
  channels_groups: 'Grupos',
  feed_related: 'Relacionados',
  feed_recommend: 'Recomendados',
  feed_empty: 'Sem feed ainda, explore grupos populares',
  feed_goToGroup: 'Ver no grupo',
  feed_joinGroupAndSendMsg: 'Entre em um grupo e envie uma mensagem',
  channel_detail_channelCode: 'Código do Grupo Octo',
  channel_detail_invitePhrase: 'Convite para "{name}"\nCódigo de convite {code} — abra o app para entrar automaticamente · A IA esclarece primeiro e encontra a pessoa certa',
  channel_detail_post: 'Publicar no Grupo',
  channel_detail_aiHint: "Digite sua mensagem no grupo e o AI esclarece os detalhes primeiro",
  channel_input_hint: 'Diga algo...',
  channel_leave_confirm_message: 'Tem certeza de que deseja sair deste grupo? Você não receberá mais mensagens do grupo.',
  channel_invite_notFound: 'Grupo não encontrado ou link expirado',
  channel_invite_joinBtn: 'Baixar o app OctoSay',
  channel_invite_hint: 'Baixe o app, depois escaneie este código QR ou pesquise o nome do grupo para entrar',
  channel_invite_globalHintTitle: 'Você está prestes a baixar a versão Global',
  channel_invite_globalHintIOS: 'Este app pode não estar disponível na App Store da China. Troque para uma Apple Store fora da China e pesquise OctoSay, ou baixe o APK diretamente abaixo.',
  channel_invite_globalHintAndroid: 'O Google Play pode não estar acessível na sua região. Recomendamos baixar o APK diretamente, ou tentar o Google Play.',
  channel_invite_globalHintDefault: 'O app pode não estar disponível na loja local. Recomendamos baixar o APK diretamente, ou tentar a App Store.',
  channel_invite_globalBtnAppStore: 'Ir para a App Store',
  channel_invite_globalBtnGooglePlay: 'Ir para o Google Play',
  channel_invite_globalBtnAPK: 'Baixar APK diretamente',
  channel_invite_defaultDesc: 'Entre no {name} no OctoSay',
  share: 'Compartilhar',
  share_channel: 'Compartilhar grupo',
  share_channel_link: 'Compartilhar link',
  channel_detail_inviteCode: 'Código de convite',
  channel_detail_copyLink: 'Copiar link',
  share_session_title: 'Uma publicação no OctoSay',
  share_match_title: 'Um match no OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Veja o que o {userName} publicou no OctoSay',
  session_share_notFound: 'Publicação não encontrada ou link expirado',
  session_share_fromChannel: 'De um Grupo Octo',
  session_share_downloadBtn: 'Baixar o app OctoSay',
  session_share_hint: 'Baixe o app para ver a publicação completa e entrar no grupo',
  session_share_openInApp: 'Abrir no app',
  toast_link_copied: 'Link copiado',
  toast_no_share_data: 'Nada para compartilhar',
  channels_joinByQR: 'Código QR',
  channels_joinByQRWebHint: 'A web não suporta leitura de QR. Digite o código do grupo para entrar.',
  channels_joinByQRTitle: 'Entrar com código QR',
  channel_detail_qrCode: 'Código QR',
  channel_detail_qrCodeSave: 'Salvar imagem',
  channel_detail_qrCodeSaveHint: 'Clique com o botão direito na imagem para salvar',
  channel_detail_qrCodeSaved: 'Salvo no álbum',
  channel_detail_qrCodeSaveFailed: 'Falha ao salvar, tente novamente',
  channel_detail_locateFailed: 'Falha ao localizar a mensagem',
  channel_detail_locateError: 'Erro ao localizar a mensagem',
  channel_detail_myMessages: 'Minhas mensagens',
  channel_detail_searchMessages: 'Pesquisar mensagens',
  channel_detail_aiChat: 'Conversa com AI',
  channel_detail_matchHistory: 'Histórico de matches',
  channel_create_title: 'Criar Grupo Octo',
  channel_create_name: 'Nome do Grupo Octo',
  channel_create_description: 'Descrição',
  channel_create_submit: 'Criar',
  channelCreate_aiAssist: 'O AI vai te ajudar a criar um grupo adequado',
  channelCreate_nameHint: 'Digite um nome para o seu grupo',
  channelCreate_descHint: 'Descreva do que se trata o seu grupo',
  channelCreate_creating: 'Criando...',
  channelCreate_created: 'Grupo criado!',
  channelCreate_failed: 'Falha ao criar o grupo',
  channelCreate_welcomeMsg: "Oi! Estou aqui para te ajudar a criar um grupo. Me diga que tipo de grupo você quer — o tema ou o propósito — e eu transformo isso num nome e numa introdução de grupo, e ainda gero um avatar.",
  channelCreate_aiHint: 'Escreva o tema do seu grupo...',
  channelCreate_clarifyingProgress: 'Organizando o tema do seu grupo...',
  channelCreate_readyToCreate: 'Pronto para criar o Grupo Octo',
  channelCreate_step1: 'Descrever o tema',
  channelCreate_step1Done: 'Ideia esclarecida',
  channelCreate_step2: 'Criar Grupo Octo',
  channelCreate_confirmBtn: 'Confirmar criação',
  channelCreate_publicNotice: "Grupos são espaços públicos para pessoas com interesses em comum se reunirem e se conectarem. A plataforma pode gerenciar, atualizar ou mesclar grupos conforme necessário. Sinta-se à vontade para compartilhar este grupo com outras pessoas que possam se interessar.",
  channelCreate_similarGroupsTitle: 'Grupos Octo semelhantes encontrados',
  channelCreate_similarGroupsDesc: 'Estes grupos podem combinar com o que você quer',
  channelCreate_exactMatchHint: 'Já existe um grupo com exatamente este nome!',
  channelCreate_joinHint: 'Estes grupos existentes podem ser uma boa escolha',
  channelCreate_joinExisting: 'Entrar em um Grupo Octo existente',
  channelCreate_stillCreate: 'Criar um novo Grupo Octo assim mesmo',
  channel_chat_session_comments: 'Comentários',
  channel_chat_session_commentHint: 'Escreva um comentário...',
  channel_chat_session_sendComment: 'Comentar',
  channel_chat_session_loadMore: 'Carregar mais',
  channel_chat_session_noComments: 'Nenhum comentário ainda',
  channel_chat_session_deleteComment: 'Excluir',
  channelSearch_title: 'Pesquisar no Grupo',
  channelSearch_placeholder: 'Pesquisar mensagens...',
  channelSearch_onlyMine: 'Apenas minhas publicações',
  channelSearch_tabAllMessages: 'Mensagens do grupo',
  channelSearch_tabMyMessages: 'Minhas mensagens',
  chatMsgSearch_placeholder: 'Pesquisar mensagens',
  chatMsgSearch_tabMsgs: 'Mensagens',
  chatMsgSearch_tabContacts: 'Contatos',
  chatMsgSearch_emptyPrompt: 'Digite palavras-chave para pesquisar mensagens',
  chatMsgSearch_tooShort: 'Digite pelo menos 2 caracteres para pesquisar',
  chatMsgSearch_contactEmptyPrompt: 'Digite um nome de usuário ou e-mail para pesquisar contatos',
  chatMsgSearch_noContacts: 'Nenhum contato correspondente',
  chatMsgSearch_inChatPlaceholder: 'Pesquisar nesta conversa',
  channelHistory_title: 'Histórico',
  channelHistory_myMessages: 'Minhas mensagens',
  channelHistory_loadMore: 'Carregar mais',
  channel_settings_push: 'Notificações do Grupo Octo',
  channel_settings_commentPush: 'Notificações de comentários',
  channel_settings_likePush: 'Notificações de curtidas',
  channel_settings_receiveNotifications: 'Receber notificações',
  channel_settings_directContact: 'Permitir contato direto',
  session_published: 'Publicado',
  session_publishFailed: 'Falha ao publicar',
  session_setDirectContactSuccess: 'Configuração salva',
  session_setDirectContactFailed: 'Falha ao salvar a configuração',
  session_setPrivate: 'Tornar privado',
  session_setPublic: 'Tornar público',
  session_pauseMatching: 'Pausar match',
  session_resumeMatching: 'Retomar match',
  session_matchPausedToast: 'Match pausado',
  session_matchResumedToast: 'Match retomado',
  match_matchingPausedTitle: 'O match está pausado',
  match_reasonTag: 'Motivo do match',
  match_matchingPausedHint: 'Retome o match quando quiser.',
  session_confirmSetPrivate: 'Tornar este conteúdo privado? Outros usuários não poderão vê-lo.',
  session_messageIsPrivate: 'Esta mensagem é privada',
  chatSessionComment_replyHint: 'Escreva um comentário...',
  chatSessionComment_reply: 'Comentar',
  chatSessionComment_count: '{n} comentário | {n} comentários',
  chatSessionMatch_count: '{n} match | {n} matches',
  chatSessionComment_replyTo: 'Responder',
  chatSessionComment_inputHint: 'Escreva um comentário...',
  chatSessionComment_send: 'Enviar',
  chatSessionComment_delete: 'Excluir',
  chatSessionComment_deleteConfirm: 'Tem certeza de que deseja excluir este comentário?',
  chatSessionComment_loadMore: 'Carregar mais',
  chatSessionComment_noMore: 'Não há mais comentários',
  chatSessionComment_loginToComment: 'Entre para comentar',
  chatSessionComment_viewEarlier: 'Ver {n} respostas anteriores',
  chatSessionLike_like: 'Curtir',
  chatSessionLike_liked: 'Curtido',
  chatSessionLike_count: 'curtidas',
  chatSessionBookmark_bookmark: 'Salvar',
  chatSessionBookmark_bookmarked: 'Salvo',
  chatSessionMatch_viewMatches: 'Ver matches',
  chatSessionMatch_matchHistory: 'Histórico de matches',
  chatSessionMatch_noMatches: 'Nenhum match ainda',
  channel_match_achievement: '{count} publicações foram match com sucesso',
  channel_match_achievement_view: 'Ver →',
  channel_matchHistory_title: 'Histórico de matches do canal',
  chatSessionMatch_matchedAt: 'Match feito em {time}',
  discover_userMsgLabel: 'O usuário disse',
  common_loading: 'Carregando...',
  common_sending: 'Enviando...',
  common_error: 'Erro',
  common_success: 'Sucesso',
  common_me: 'Eu',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "A IA está esclarecendo sua necessidade para que cada mensagem publicada funcione; depois de publicar, continua te trazendo matches",
  aiChat_clarifyingAlmostDone: 'Quase lá, confirme por favor',
  aiChat_clarifyingOneMore: 'Falta cerca de 1 pergunta, depois você pode publicar',
  aiChat_clarifyingRemaining: 'Faltam cerca de {count} rodadas, quase lá',
  aiChat_clarifyingEvaluating: 'Avaliando o progresso...',
  aiChat_setPublicMatch: 'Tornar público e dar match',
  aiChat_needsClarifiedPublic: "Agora eu te entendo. Assim que você confirmar e publicar, o AI continuará encontrando matches para você.\nSinta-se à vontade para compartilhar mais detalhes a qualquer momento.",
  aiChat_needsClarifiedPrivate: 'Entendi! Torne público e deixe eu continuar encontrando matches para você!\nConte mais detalhes quando quiser.',
  aiChat_setPublicTitle: 'Tornar público',
  aiChat_setPublicMessage: 'Seu conteúdo ficará visível para os outros para que o OctoSay encontre matches complementares para você.\n\nInformações que serão compartilhadas:\n• Seu nome de usuário e avatar\n• O resumo do seu conteúdo\n• O conteúdo da conversa (visível em Descobrir)\n\nVocê pode torná-lo privado novamente a qualquer momento.',
  aiChat_findMatches: 'Ver resultado do match',
  aiChat_publishing: 'Publicando...',
  aiChat_matchSectionTitle: 'Sua mensagem combina mais com estes grupos — toque para publicar',
  aiChat_joinedBadge: 'Membro',
  aiChat_matchSectionEmpty: 'Ainda não há grupos com boa correspondência — você pode criar um novo grupo e publicar lá',
  aiChat_suggestPublishCreateNew: 'Criar um novo grupo',
  aiChat_repickChannel: 'Trocar de grupo',
  aiChat_creatingChannelTitle: 'Nenhum grupo adequado — criando um para você',
  aiChat_creatingChannelHint: 'A IA está criando um grupo para seu pedido e depois você publica direto — geralmente 10-30 s',
  aiChat_publishToChannelHint: 'Será publicado em "{name}"',
  aiChat_pickChannelTitle: 'Escolha um grupo para publicar',
  aiChat_matchingChannelTitle: 'Procurando o grupo certo para você',
  aiChat_matchingChannelHint: 'A IA está pesquisando com base no seu pedido — geralmente de alguns segundos a meio minuto',
  aiChat_matchUnavailableTitle: 'Recomendações indisponíveis',
  aiChat_matchUnavailableHint: 'Pesquise um grupo abaixo ou feche e abra a publicação novamente',
  aiChat_waitSlowHint: 'Está demorando mais que o normal, mas ainda está em andamento — aguarde um pouco mais ou pesquise um grupo abaixo',
  aiChat_creatingSlowHint: 'A criação está mais lenta que o normal, mas ainda está em andamento — depois você publica direto',
  aiChat_pickChannelEmptyHint: 'Nenhum grupo relacionado encontrado. Crie um novo grupo e publique sua mensagem',
  aiChat_loadMore: 'Carregar mais',
  sidebar_publish: 'Publicar',
  chat_selectLocationOnMap: 'Selecione um local no mapa',

  // App.vue new
  placeholder_email: 'Digite seu e-mail',
  placeholder_mobile: 'Digite seu número de celular',
  placeholder_password: 'Digite sua senha',
  placeholder_name: 'Digite seu nome',
  random_nickname: 'Aleatório',
  placeholder_verification_code: 'Digite o código de verificação',
  sending: 'Enviando...',
  registering: 'Cadastrando...',
  send_code: 'Enviar código',
  retry_in_seconds: 'Tentar novamente em {countdown}s',
  toast_enter_email: 'Digite seu e-mail',
  toast_enter_mobile: 'Digite seu número de celular',
  toast_invalid_email: 'Digite um formato de e-mail válido',
  toast_invalid_mobile: 'Digite um número de celular válido',
  toast_send_code_failed: 'Falha ao enviar o código de verificação',
  toast_code_sent: 'Código de verificação enviado para o e-mail',
  toast_code_sent_sms: 'Código de verificação enviado para o celular',
  toast_send_code_error: 'Falha ao enviar o código de verificação, tente novamente mais tarde',
  toast_fill_all_fields: 'Preencha todos os campos',
  toast_login_failed: 'Falha ao entrar',
  toast_login_success: 'Login bem-sucedido',
  oauthOr: 'ou',
  toast_oauth_login_failed: 'Falha no login com Google',
  toast_oauth_login_error: 'Erro no login com Google, tente novamente',
  toast_login_error: 'Falha ao entrar, tente novamente mais tarde',
  toast_register_failed: 'Falha no cadastro',
  toast_register_success: 'Cadastro bem-sucedido',
  toast_register_error: 'Falha no cadastro, tente novamente mais tarde',

  // AdBanner.vue
  ad: 'Anúncio',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Antes de conectar',
  contactAd_gateSubtitle: 'Esta breve pausa mantém o OctoSay gratuito — obrigado pelo seu apoio!',
  contactAd_waitBtn: 'Continuar em {sec}s',
  contactAd_continueBtn: 'Continuar para o chat',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Conversar',

  // AiMatch.vue
  ai_welcome_msg: 'Oi, sou o AI. Me diga o que está pensando — um par, um parceiro, troca de habilidades, ou QUALQUER coisa.',
  default_username: 'Usuário',

  // AvatarCropDialog.vue
  crop_hint: 'Pinça para dar zoom, arraste para ajustar',
  toast_crop_failed: 'Falha ao recortar a imagem',

  // ChatBox.vue
  loading_match_info: 'Carregando informações do match...',
  view_match_details: 'Ver detalhes do match',
  step_clarify_needs: 'Esclarecer',
  step_ai_matching: 'Publicar no Grupo',
  step_connect: 'Match de IA',
  make_private: 'Tornar privado',
  setting: 'Configurando...',
  action_photo: 'Foto',
  action_file: 'Arquivo',
  action_video: 'Vídeo',
  action_location: 'Localização',
  hint_get_app: 'Baixe o app para continuar conectado',
  match_finding_title: 'Seus matches',
  match_finding_subtitle: 'O AI continua buscando matches para você',
  match_time_hint: 'Este processo geralmente leva de 1 a 2 minutos',
  match_result_stats: 'Encontramos {matched} melhores matches{interested}',
  match_tap_to_connect: 'Toque para iniciar sua conversa',
  match_channel_hint: 'Fazendo match no grupo <strong>#{channel}</strong>. Priorizamos matches do mesmo grupo, mas podem incluir outros grupos quando necessário.',
  label_perfect_match: 'Melhor match',
  label_worth_a_look: 'Vale a pena ver',
  match_no_result_title: 'Ainda buscando matches para você',
  match_no_result_desc: 'Compartilhe mais detalhes para ajudar o OctoSay a encontrar os matches certos. Instale o app para receber notificações quando alguém der match com você.',
  go_back: 'Voltar',
  no_public_requirements: 'Nenhuma publicação pública ainda',
  channelEmpty_title: 'Está calmo por aqui',
  channelEmpty_subtitle: 'Seja o primeiro a compartilhar seus pensamentos',
  channelEmpty_hint: "Escreva suas ideias e o AI te ajuda a esclarecer e receba matches continuamente, para que sua mensagem não fique esquecida",
  channelEmpty_action: 'Compartilhe seus pensamentos',
  stay_connected: 'Fique conectado',
  download_app_desc: 'Baixe o app para conversar e receber notificações na hora quando alguém se conectar com você!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK direto',
  match_history: 'Histórico de matches',
  no_match_history: 'Nenhum histórico de matches ainda',
  finding_matches: 'O AI continua buscando matches para você - Depois de publicar uma mensagem em um grupo',
  discover_connect_hint: 'Você poderá conversar com eles quando der match!',
  match_initializing: 'Inicializando...',
  placeholder_login_to_chat: 'entre para me contar o que está pensando',
  toast_need_clear: 'Sua ideia está clara!',
  toast_ai_responding: 'O AI está respondendo, aguarde...',
  toast_uploading_image: 'Enviando imagem, aguarde...',
  toast_uploading_file: 'Enviando arquivo, aguarde...',
  toast_max_photos: 'Máximo de {max} fotos permitidas',
  toast_uploading: 'Enviando, aguarde...',
  toast_file_too_large: '{name} excede o limite de 5MB',
  toast_video_too_large: '{name} excede o limite de 20MB',
  toast_video_processing: 'O vídeo está sendo processado, aguarde...',
  toast_upload_link_failed: 'Falha ao obter o link de envio',
  analyzing_image: 'Analisando a imagem...',
  toast_location_confirmed: 'Localização confirmada',
  toast_location_selected: 'Localização selecionada',
  toast_enter_search: 'Digite o conteúdo da pesquisa',
  toast_search_failed: 'Falha na pesquisa',
  toast_no_locations: 'Nenhum local encontrado',
  toast_search_error: 'Falha na pesquisa, tente novamente',
  toast_located_at: 'Localizado em: {address}',
  toast_shared_finding: 'Compartilhado! Buscando matches...',
  toast_update_failed: 'Falha ao atualizar',
  toast_set_private: 'Tornado privado',
  toast_no_matches: 'Nenhum match encontrado',
  toast_matches_found: 'Encontramos {count} melhores matches',
  toast_start_conversation_first: 'Inicie uma conversa primeiro',
  toast_load_history_failed: 'Falha ao carregar o histórico de matches',
  toast_ai_timeout: 'O AI demorou demais, tente novamente',
  toast_message_blocked: 'Mensagem bloqueada',
  network_disconnected: 'Rede desconectada',
  toast_publish_success: 'Publicado no grupo!',
  toast_publish_failed: 'Falha ao publicar no grupo',

  // ChatMsgList.vue
  collapse_thinking: 'recolher o raciocínio',
  expand_thinking: 'expandir o raciocínio',
  thinking: 'pensando',
  select_date: 'Selecionar data',
  selected_location: 'Localização selecionada',
  msg_blocked: 'Bloqueada',
  retry: 'Tentar novamente',
  msg_read: 'Lida',
  msg_sent: 'Enviada',
  msg_unread: 'Não lida',
  label_start_datetime: 'Data e hora de início:',
  label_end_datetime: 'Data e hora de término:',
  toast_select_start_datetime: 'Selecione a data e hora de início',
  toast_end_before_start: 'A data/hora de término não pode ser anterior à de início',
  report_message: 'Denunciar mensagem',
  block_user: 'Bloquear usuário',
  msg_revoke: 'Recuperar',
  msg_quote: 'Citar',
  msg_revoked_self: 'Você recuperou uma mensagem',
  msg_revoked_other: 'A outra pessoa recuperou uma mensagem',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Mensagem recuperada',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Esta mensagem foi removida pela plataforma devido a uma violação',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Mensagem recuperada',
  toast_revoke_failed: 'Falha ao recuperar a mensagem',
  toast_load_data_failed: 'Falha ao carregar os dados, atualize a página.',
  toast_file_url_missing: 'URL do arquivo não encontrada',
  toast_block_success: 'Usuário bloqueado com sucesso',
  toast_block_failed: 'Falha ao bloquear o usuário',

  // ChatSession.vue
  no_more_records: 'não há mais registros.',
  title_needs_clarified: 'Pensamentos esclarecidos',
  title_clarifying: 'Esclarecendo seus pensamentos',
  title_public: 'Público',
  title_private: 'Privado',
  badge_clarified: 'Esclarecido',
  badge_clarifying: 'Esclarecendo',
  badge_only_me: 'Somente eu',
  badge_expired: 'Expirado',
  title_expired: 'Expirado',
  no_chat_history: 'Sem histórico de conversa',

  // ContactMethods.vue
  block_status_banner: 'Você bloqueou este usuário',
  unblock_user: 'Desbloquear',
  toast_block_missing_id: 'Não é possível bloquear: ID do usuário ausente',
  dialog_block_confirm: 'Tem certeza de que deseja bloquear {name}? Você não receberá nenhuma mensagem desta pessoa.',
  toast_user_blocked: '{name} foi bloqueado',
  toast_unblock_missing_id: 'Não é possível desbloquear: ID do usuário ausente',
  toast_user_unblocked: '{name} foi desbloqueado',

  // BlockedUsers.vue
  blocked_users: 'Usuários bloqueados',
  blocked_users_empty: 'Nenhum usuário bloqueado',
  blocked_users_empty_hint: 'Usuários bloqueados não poderão mais te enviar mensagens',
  blocked_users_unblock: 'Desbloquear',
  dialog_unblock_confirm: 'Depois de desbloquear, a pessoa poderá te enviar mensagens novamente.',
  toast_unblock_success: 'Desbloqueado',
  toast_unblock_failed: 'Falha ao desbloquear, tente novamente',
  blocked_users_load_failed: 'Falha ao carregar. Toque para tentar novamente',
  blocked_users_blocked_at: 'Bloqueado {date}',
  blocked_users_unknown_user: 'Usuário desconhecido',

  // Contacts.vue
  no_connections: 'Nenhuma mensagem ainda',
  chat_with: 'Conversar com {name}',
  toast_load_contacts_failed: 'Falha ao carregar conexões: {msg}',
  toast_load_contacts_error: 'Falha ao carregar conexões. Atualize e tente novamente.',
  time_just_now: 'Agora mesmo',
  time_minutes_ago: 'há {min} min',
  time_hours_ago: 'há {hour} h',
  time_days_ago: 'há {day} d',

  // InteractionNotification.vue
  interaction_notification_title: 'Notificações',
  interaction_notification_subtitle: 'Comentários e curtidas',
  interaction_notification_empty: 'Nenhuma notificação ainda',
  interaction_notification_comment: 'comentou: {content}',
  interaction_notification_like: 'curtiu sua publicação',
  interaction_notification_reply: 'respondeu: {content}',
  interaction_notification_bookmark: 'salvou sua publicação',
  toast_load_notifications_failed: 'Falha ao carregar notificações: {msg}',
  toast_load_notifications_error: 'Falha ao carregar notificações. Atualize e tente novamente.',
  mark_all_read: 'Marcar tudo como lido',
  toast_mark_all_read_failed: 'Falha na operação, tente novamente',
  contacts_dnd: 'Silenciar notificações',
  dnd_enabled: 'Notificações silenciadas',
  dnd_disabled: 'Notificações reativadas',
  dnd_action_enable: 'Silenciar notificações',
  dnd_action_disable: 'Reativar notificações',

  // Discover.vue
  toast_load_sessions_failed: 'Falha ao carregar sessões: {msg}',
  toast_load_sessions_error: 'Falha ao carregar sessões',
  discover_noMessages: 'Nenhuma mensagem ainda',

  // EmojiInputArea.vue
  placeholder_default: 'Compartilhe mais detalhes com o AI',
  userChat_typeMessage: 'Digite uma mensagem...',
  select_emoji: 'Selecionar emoji',
  badge_new: 'novo',
  channel_search_placeholder: 'Digite o canal',
  channel_picker_empty: 'Digite o canal',

  // FrontPage.vue
  tab_chat_with_ai: 'Deixe o OctoSay te entender',
  history_chats: 'Histórico',
  tab_connections: 'Matches',
  tab_conversations: 'Mensagens',
  tab_profile: 'Perfil',
  new_session: 'Novo',
  history_tab_chats: 'Meu',
  history_tab_matches: 'Matches',
  channels_octosay: 'Grupos Octo',
  tab_matches: 'Matches',
  tab_messages: 'Mensagens',

  // Header.vue
  slogan: 'OctoSay - A IA que te entende e te conecta com a pessoa certa',
  app_name: 'OctoSay',
  slogan_short: 'A IA que te entende e te conecta com a pessoa certa',
  slogan_ai: 'A IA que te entende e te conecta com a pessoa certa',
  get_the_app: 'Baixar o app',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'ou pesquise OctoSay nas lojas de apps',

  // MapLocationPicker.vue
  placeholder_search_location: 'Pesquisar local...',
  coords_display: 'Longitude: {lng}, Latitude: {lat}',
  toast_no_geolocation: 'Seu navegador não suporta geolocalização',
  toast_location_permission_denied: 'Não foi possível obter sua localização, verifique as permissões de localização',
  loading_address: 'Carregando endereço...',

  // MatchedSession.vue
  created_at: 'Criado: {time}',
  ai_match_analysis: 'Análise de match do AI',
  error_missing_session_params: 'Faltam parâmetros de sessão obrigatórios',
  match_private_hint: 'Esta sessão é privada. O conteúdo não está disponível',

  // PersonalCenter.vue
  label_name: 'Nome:',
  placeholder_enter_name: 'Digite seu nome',
  label_bio: 'Bio:',
  placeholder_enter_bio: 'Escreva algo sobre você',
  placeholder_bio_empty: 'Diga algo sobre você',
  bio: 'Bio',
  delete_account: 'Excluir conta',
  delete_warning: 'Esta ação não pode ser desfeita.',
  delete_data_intro: 'Os seguintes dados serão excluídos permanentemente:',
  delete_item_profile: 'As informações do seu perfil',
  delete_item_chat: 'Histórico e sessões de conversa',
  delete_item_contact: 'Informações de contato',
  delete_item_all: 'Todos os dados associados',
  final_confirmation: 'Confirmação final',
  delete_confirm_prompt: 'Digite "delete" para confirmar:',
  placeholder_type_delete: 'Digite delete',
  private_token: 'Token privado',
  token_desc: 'Gere um token para acesso à API',
  toast_not_logged_in: 'Usuário não conectado',
  toast_name_required: 'O nome é obrigatório',
  toast_save_success: 'Salvo com sucesso',
  toast_save_failed: 'Falha ao salvar',
  toast_image_too_large: 'A imagem excede o limite de 5MB',
  toast_avatar_updated: 'Avatar atualizado',
  toast_avatar_failed: 'Falha ao atualizar o avatar',
  toast_upload_failed: 'Falha no envio',
  toast_token_generated: 'Token gerado',
  toast_token_failed: 'Falha ao gerar o token',
  toast_copied: 'Copiado para a área de transferência',
  toast_copy_failed: 'Falha ao copiar',
  toast_account_deleted: 'Conta excluída com sucesso',
  toast_delete_account_failed: 'Falha ao excluir a conta',
  toast_logout_success: 'Logout bem-sucedido',
  toast_logout_failed: 'Falha ao sair',
  profile_tab_messages: 'Mensagens',
  profile_tab_comments: 'Comentários',
  profile_tab_likes: 'Curtidas',
  profile_tab_bookmarks: 'Salvos',
  profile_empty_messages: 'Nenhuma mensagem ainda',
  profile_empty_comments: 'Nenhum comentário ainda',
  profile_empty_likes: 'Nenhuma curtida ainda',
  profile_empty_bookmarks: 'Nada salvo ainda',
  profile_reply_to: 'Responder a {name}',
  profile_stats_posts: 'Mensagens',
  profile_stats_comments: 'Comentários',
  profile_stats_likes: 'Curtidas recebidas',
  profile_joined: 'Entrou em {date}',

  // ReportDialog.vue
  report_message_title: 'Denunciar mensagem',
  report_reason_prompt: 'Selecione o motivo para denunciar esta mensagem:',
  report_spam: 'Spam',
  report_harassment: 'Assédio ou intimidação',
  report_inappropriate: 'Conteúdo inadequado',
  report_other: 'Outro',
  placeholder_report_desc: 'Descreva o problema (opcional)',
  toast_select_reason: 'Selecione um motivo',
  toast_report_success: 'Denúncia enviada com sucesso',
  toast_report_failed: 'Falha ao enviar a denúncia',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Imagem]',
  summary_images: '[Imagens x{count}]',
  summary_file: '[Arquivo]',
  summary_files: '[Arquivos x{count}]',
  summary_video: '[Vídeo]',
  summary_videos: '[Vídeos x{count}]',
  summary_location: '[Localização]',
  summary_locations: '[Localizações x{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emojis x{count}]',
  summary_voice: '[Mensagem de voz]',
  summary_voices: '[Mensagens de voz x{count}]',
  summary_mixed: '[Misto]',
  summary_other: '[Outro]',

  // Voice messages
  voice: 'Mensagem de voz',
  voice_recording: 'Gravando...',
  toast_voice_too_short: 'Gravação muito curta',
  toast_voice_failed: 'Falha ao enviar a mensagem de voz',
  toast_mic_permission_denied: 'Não foi possível acessar o microfone. Ative-o nas configurações do navegador',
  toast_recording_not_supported: 'A gravação de voz não é compatível com este navegador',
  voice_load_failed: 'Falha ao carregar a mensagem de voz',

  // Expire At
  aiChat_expireLine: "Válido até {date}, diga ao AI a qualquer momento para atualizar",
  aiChat_expireExpired: "O conteúdo expirou e não está mais visível para os outros. Diga ao AI a qualquer momento para atualizar a expiração",

  // MatchedSession.vue
  detail: 'Detalhe',

  // Match notification hints
  match_new_result_hint: 'Se houver novos resultados de match, você será notificado por e-mail. Para uma melhor experiência, instale o app e receba notificações na hora.',

  // Match notification hints
  match_connection_notify_hint: 'Match feito e notificado! Vá dizer oi!',
  match_continuousMatching: "O AI está continuamente encontrando matches para você",
  match_continuousMatchingHint: 'Avisaremos assim que encontrarmos novos matches',
  match_continuousMatchingOthers: "O AI está continuamente encontrando matches para eles",
  match_continuousMatchingOthersHint: 'Novos matches aparecerão aqui conforme forem encontrados',
  match_noResultsTitleOthers: 'Ainda buscando matches para essa pessoa',
  match_noResultsHintOthers: "O AI está continuamente encontrando matches para eles. Os resultados aparecerão aqui quando encontrados.",
  match_newMatchFound: '{n} novos matches encontrados!',
  match_worth_exploring_hint: 'Você decide se quer entrar em contato.',

  // Matches filter tags
  filter_all: 'Todos',
  filter_best_connection: 'Melhor match',
  filter_worth_a_look: 'Vale a pena ver',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - A IA que te entende e te conecta com a pessoa certa',
  landing_hero_title: 'Escreva no seu grupo — o AI esclarece primeiro, depois você publica e recebe matches.',
  landing_hero_subtitle: 'Escreva a mensagem que você quer compartilhar em um Grupo Octo. Antes de ir ao ar, o AI conversará com você para acertar os detalhes. Depois que você confirmar, sua mensagem e o resumo da IA são publicados juntos, e o AI começa o matching.',
  landing_download_on: 'Baixar na',
  landing_get_it_on: 'Disponível na',
  landing_direct_download: 'Download direto',
  landing_how_title: 'Como funciona',
  landing_step1_title: 'Escreva no Grupo',
  landing_step1_desc: 'Escreva a mensagem que você quer compartilhar no grupo. A IA conversará com você primeiro para esclarecer os detalhes, assim cada publicação fica clara, útil e pronta para o matching — sem se perder no ruído.',
  landing_step2_title: 'Confirme, publique e receba matches',
  landing_step2_desc: 'Quando você confirmar, sua mensagem original e o resumo da IA são publicados juntos no grupo. Depois, a IA continua encontrando seus melhores matches, para que sua mensagem não fique enterrada ou seja ignorada.',
  landing_step3_title: 'Conecte-se e converse',
  landing_step3_desc: 'Quando um match acontece, ambos podem ver o histórico de conversa um do outro com o AI e o resumo da IA. Com um contexto em comum, quebrar o gelo é fácil — basta conversar naturalmente.',
  // Comparison Section
  landing_comparison_title: 'Por que o OctoSay?',
  landing_comparison_subtitle: 'Conversa em grupo, mas o AI esclarece seus detalhes e te dá match ativamente.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Qualidade do conteúdo',
  landing_cmp1_other: 'Enchente de spam, anúncios e mensagens fora de contexto',
  landing_cmp1_octo: 'Somente cartões de demanda selecionados por IA',
  landing_cmp2_label: 'Encontrar pessoas',
  landing_cmp2_other: 'Publicar e só esperar respostas',
  landing_cmp2_octo: 'O AI dá match em você ativamente',
  landing_cmp3_label: 'Nível de ruído',
  landing_cmp3_other: 'Centenas de mensagens para rolar',
  landing_cmp3_octo: 'Zero ruído, cada publicação importa',
  landing_cmp4_label: 'Para começar',
  landing_cmp4_other: 'Procurar servidor, navegar canais, se virar sozinho',
  landing_cmp4_octo: 'Escreva no grupo; o AI esclarece e dá match',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Conversas de grupo tomadas por anúncios e spam',
  landing_cmp1_xhs: 'Publicações promocionais por toda parte, difíceis de confiar',
  landing_cmp1_facebook: 'Anúncios e manchetes chamativas tomam seu feed',
  landing_cmp1_reddit: 'Spam e publicações fora de contexto por toda parte',
  landing_cmp2_wechat: 'Somente por contatos e convites de grupo',
  landing_cmp2_xhs: 'Pesquisar por conta própria e garimpar publicações',
  landing_cmp2_facebook: 'Limitado aos seus amigos e grupos existentes',
  landing_cmp2_reddit: 'Navegar por subreddits sozinho e torcer por respostas',
  landing_cmp3_wechat: 'Rolar centenas de mensagens de grupo',
  landing_cmp3_xhs: 'Feed cheio de recomendações e anúncios',
  landing_cmp3_facebook: 'Publicações recomendadas e anúncios sem fim',
  landing_cmp3_reddit: 'Centenas de comentários para rolar',
  landing_cmp5_label: 'Quem faz a busca',
  landing_cmp5_wechat: 'Perguntar um a um, torcendo pela sorte',
  landing_cmp5_xhs: 'Publicar, esperar comentários e filtrar sozinho',
  landing_cmp5_facebook: 'Você precisa perguntar por aí nos grupos',
  landing_cmp5_reddit: 'Publicar, esperar respostas e depois filtrar',
  landing_cmp5_octo: 'A IA continua encontrando pessoas para você, automaticamente',

  landing_features_title: 'Recursos principais',
  landing_feature1_title: 'Esclarecer antes de publicar',
  landing_feature1_desc: 'Nenhum formulário para preencher. Escreva sua mensagem no grupo e o AI conversará primeiro com você, fazendo as perguntas certas e entendendo de verdade o que você precisa.',
  landing_feature2_title: 'Limpo, não caótico',
  landing_feature2_desc: 'Sua mensagem e o resumo da IA são publicados juntos — o OctoSay faz a curadoria de cada publicação, então sem spam, sem enchente fora de contexto, sem ruído para rolar.',
  landing_feature3_title: 'Matching proativo',
  landing_feature3_desc: 'Depois que você confirma e sua mensagem + resumo de IA vão ao ar, o AI varre o grupo continuamente para encontrar pessoas que combinem com o que você procura — e explica o porquê.',
  landing_feature4_title: 'Comunidades por tema, zero ruído',
  landing_feature4_desc: 'Entre em grupos por tema — esportes, games, intercâmbio de idiomas, colega de quarto — a IA esclarece sua mensagem antes de publicar, para que cada grupo fique limpo e útil.',
  landing_feature5_title: 'Privacidade protegida',
  landing_feature5_desc: 'Você pode tornar as mensagens privadas depois de enviar, visíveis apenas para você. Controle total.',
  landing_feature6_title: 'Conversas com significado',
  landing_feature6_desc: 'Sem ruído, sem distrações — cada mensagem importa.',
  landing_usecases_title: 'Funciona para qualquer cenário',
  landing_usecases_subtitle: 'Seja o que for que você tenha em mente, entre em um grupo por tema — o AI cuida do matching para você não precisar rolar e pesquisar',
  landing_usecase_game: 'Parceiro de game',
  landing_usecase_language: 'Intercâmbio de idiomas',
  landing_usecase_skill: 'Troca de habilidades',
  landing_usecase_roommate: 'Encontrar colega de quarto',
  landing_usecase_travel: 'Companheiro de viagem',
  landing_usecase_sports: 'Parceiro de esporte',
  landing_usecase_study: 'Parceiro de estudos',
  landing_usecase_anything: '...ou compartilhe qualquer coisa',
  landing_cta_title: 'Pronto para começar?',
  landing_cta_desc: 'Entre em um grupo por tema, escreva o que você quer compartilhar, deixe o AI esclarecer os detalhes, depois publique e receba matches com as pessoas certas.',
  landing_use_now: 'Usar agora',
  landing_groups: 'Grupos',

  // OnboardingPage.vue
  onboarding_skip: 'Pular',
  onboarding_next: 'Avançar',
  onboarding_getStarted: 'Começar',
  onboarding_step1Title: "Diga o que você precisa no grupo",
  onboarding_step1Desc: "Seja o que você procura ou quer fazer, é só dizer. A IA conversa com você para esclarecer os detalhes e transforma tudo em uma mensagem clara.",
  onboarding_step2Title: 'Confirme, publique e receba matches',
  onboarding_step2Desc: "Quando sua mensagem é publicada no grupo, a IA continua encontrando os melhores matches, para sua mensagem não ficar enterrada ou ignorada.",
  onboarding_step3Title: 'Conecte-se e converse',
  onboarding_step3Desc: "Os dois lados podem ver a conversa um do outro com a IA e saber o que a pessoa procura. Com contexto compartilhado, quebrar o gelo é fácil — é só conversar naturalmente.",

  // ChannelDetail.vue
  channel_image_limit: 'Máximo 1 imagem',

  // ChannelMembers.vue
  channel_members_empty: 'Nenhum membro ainda',
  channel_members_title: 'Membros',
  channel_role_owner: 'Proprietário',
  channel_role_admin: 'Admin',
  channel_role_member: 'Membro',

  // Settings.vue
  settings_language: 'Idioma',
  settings_language_followSystem: 'Conforme o sistema',

  // ChatBox.vue
  match_interested_suffix: ', {count} para conferir',

  // ChatBox.vue - Estágios do progresso de combinação com IA
  match_stage_fetch_chat: 'Obtendo conversa',
  match_stage_query_expansion: 'Expandindo consultas',
  match_stage_semantic_search: 'Busca semântica',
  match_stage_deep_search: 'Análise profunda',
  match_stage_rerank: 'Combinação inteligente',
  match_stage_refining: 'Otimizando resultados',
  match_stage_fetch_details: 'Obtendo detalhes',

  // ChannelDetail.vue - Envio de imagens
  channel_select_image: 'Selecione um arquivo de imagem',
  channel_image_upload_failed: 'Falha ao enviar a imagem, tente novamente',
  chatInput_channelSearchHint: "Buscar grupos",
}



// WEBPACK FOOTER //
// ./src/i18n/pt.js